import getuser from '../aws_utils/getAuthuser';
import { addProjectChat } from '../apigateway/mongocalls';
import { invokeImageAgentApi } from '../apigateway/agentcalls';




export default async function invokegimageagent(query, projectname, cogid) {

    let query_key = ""
    query_key = query

    const qk = query_key.split(' ').slice(0, 6).join(' ')

    // Invoke Lambda
    // let resp = ""
    // try {
    //     const config = {
    //         region: 'us-east-1',
    //         credentials: {
    //             accessKeyId: process.env.REACT_APP_REALM_AWSID,
    //             secretAccessKey: process.env.REACT_APP_REALM_AWSKEY
    //     }}
    //     const client = new LambdaClient(config);
    //     // console.log("Client", client)


    //     const input = { // InvocationRequest
    //       FunctionName: "arn:aws:lambda:us-east-1:457968394077:function:gimageagent", // required
    //     //   InvocationType: "Event",
    //       LogType: "Tail",
    //     //   ClientContext: "STRING_VALUE",
    //       Payload: JSON.stringify({
    //                 "query" : query,
    //                 "cogid" : cogid,
    //                 "key" : qk,
    //                 "projectname" : projectname
    //                 // "memory" : memory,
    //             }),
    //     //   Qualifier: "STRING_VALUE",
    //     };

    //     // console.log("Input", input)


    //     const command = new InvokeCommand(input);
    //     // console.log("COmmand", command)


    //     const response = await client.send(command);
    //     // console.log(response)
    //     const payloadString = String.fromCharCode.apply(null, response.Payload);
    //     resp = payloadString
    //     // console.log("Lambda Response", payloadString)
    //     // return payloadString
        
    // } catch (error) {
 
    //     console.log(error)
    //     return `error`
        
    // }
    // const data = JSON.parse(resp)
    // console.log("Data", data)
    // // console.log("Data Body", data.body)
    // const image_body = data.body
    
    
    
    const resp = await invokeImageAgentApi(query, cogid, qk, projectname)
    // console.log('image agent resp', resp)


let userid = ""
try {
    const user = await getuser()
    userid = user.username
    
} catch (error) {
    console.log(error)
}
// console.log("User Id", userid)


    // console.log("resp intial", resp)
    
    


    // console.log("data from body", image_body.data)
    // console.log("key from body", image_body.key)

    const image_key = resp.key
    const new_prompt = resp.data[0].revised_prompt

  
        // const url = await StorageGet(image_key)
        // // console.log("url", url)
  

     const addChatPackage = {
            "project": projectname,
            "userId": userid,
            "query": query,
            "response" : new_prompt,  
            "image_url" : image_key,  
            "image": true,
            "agent" : "image agent"
            }
        const result = await addProjectChat(addChatPackage);
       
    
    const output = {
        "result": result,
        "response": image_key
    }
    // console.log("output", output)
    
    return output

}
